<template>
  <div class="flights-list container">
    <breadcrumb v-if="!isMobile" crumb="flights" />
    <search-flights @search="onSearch" />
    <el-table
      v-if="loading || !flightsList.length"
      v-loading="loading"
      :data="flightsList"
      style="width: 100%; height: 40vh"
    />
    <section v-if="flightsList.length && !loading" class="container">
      <el-row :gutter="24" class="titles">
        <el-col :span="2">
          <el-checkbox
            v-model="checkAll"
            :indeterminate="indeterminate"
            @change="onCheckAll"
          />
        </el-col>
        <el-col :span="access ? 22 : 18">
          <el-col :span="access ? 6 : 8" class="direction">
            Дата, направление и заказчик
          </el-col>
          <el-col :span="access ? 3 : 4">Авто/прицеп</el-col>
          <el-col :span="access ? 5 : 7">Перевозчик/водитель</el-col>
          <el-col v-if="access" :span="3">Цена</el-col>
          <el-col :span="access ? 4 : 5">АКТЫ И ТТН</el-col>
          <el-col v-if="access" :span="3">ОПЛАТЫ</el-col>
        </el-col>
      </el-row>
      <el-checkbox-group v-model="checked" @change="onCheckOne">
        <flights-item
          v-for="flight in flightsList"
          :key="flight.id"
          :flight="flight"
          :open="setOpen"
          :close="setClose"
          @comment="updateByRoute"
        />
      </el-checkbox-group>
      <div class="pagination bottom-section">
        <pagination :data="pagination" @changed="changePage" />
      </div>

      <flights-footer :items="checkedFlightsList" />
    </section>
    <modal-ttn
      :response="TTNMode"
      :shortage="shortage"
      :load-date="loadDate"
      :type="bid.type_code"
      @close="TTNMode = null"
      @update="updateTTN"
    />
    <bids-act-modal
      :act-dialog="actModal"
      :response="activeResponse"
      :active-act="activeAct"
      :doc-types="getDocumentTypes"
      @close="() => setClose('actModal')"
      @update="updateAct"
      @status="id => updateFlight(false, id)"
      @set="updateResponse"
    />
    <bids-payments-modal
      v-if="access"
      :payment-dialog="paymentModal"
      :loading="paymentLoading"
      :paying-loader="payingLoader"
      :payments-list="paymentsList"
      :response="activeResponse"
      :active-act="activeAct"
      :bid="bid"
      @close="() => setClose('paymentModal')"
      @update="updateFlight"
    />
    <el-dialog
      :visible="pasportModal"
      append-to-body
      width="50%"
      @close="setClose('pasportModal')"
    >
      <passport-fill
        v-if="pasportModal"
        :current-person="activeResponse"
        :type="bid.type_code"
      />
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import BidsActModal from '@/views/LoadDay/Modals/Act/BidsActModal'
import BidsPaymentsModal from '@/views/LoadDay/Modals/Payments/BidsPaymentsModal'
import Breadcrumb from '@/components/Breadcrumbs/Breadcrumb'
import FlightsFooter from './components/FlightsFooter'
import FlightsItem from './components/FlightsItem'
import ModalTtn from '@/components/Modals/ModalTTN'
import Pagination from '@/components/Tables/PaginationCustom'
import PassportFill from '@/components/Forms/PassportFill'
import SearchFlights from './components/SearchFlights'

export default {
  name: 'Flights',
  components: {
    Breadcrumb,
    SearchFlights,
    FlightsItem,
    Pagination,
    PassportFill,
    ModalTtn,
    BidsActModal,
    BidsPaymentsModal,
    FlightsFooter,
  },
  data() {
    return {
      checkAll: false,
      indeterminate: false,
      pasportModal: false,
      paymentModal: false,
      actModal: false,
      TTNMode: null,
      response: null,
      checked: [],
      page: 1,
      search: {},
      type_code: '',
    }
  },
  computed: {
    ...mapGetters({
      flightsList: 'responses/flightsList',
      getFlights: 'responses/getFlights',
      pagination: 'responses/getPagination',
      getLoading: 'responses/getLoading',
      getFlightById: 'responses/getFlightById',
      paymentLoading: 'payments/getLoading',
      payingLoader: 'payments/getLoader',
      paymentsList: 'payments/getPayments',
    }),
    loading() {
      return this.getLoading()
    },
    access() {
      return this.canAction('flightsAccess')
    },
    shortage() {
      const res = {}

      if (this.TTNMode && this.TTNMode.bid) {
        const { allow_shortage_is_percents, allow_shortage } = this.TTNMode.bid

        res.perc = allow_shortage_is_percents
        res.val = allow_shortage || 0
      }

      return res
    },
    bid() {
      return this.response && this.response.bid ? this.response.bid : {}
    },
    loadDate() {
      return this.response && this.response['load-day']
        ? this.response['load-day'].load_date
        : ''
    },
    activeAct() {
      if (!this.response || !this.response.id) {
        return {}
      }
      const acts = this.getFlights(this.response.id, 'Act')

      return acts.find(c => c.files.length) || acts[0]
    },
    activeResponse() {
      if (!this.response || !this.response.id) {
        return null
      }
      const res = { ...this.getFlightById(this.response.id) }

      if (!res.auto) {
        res.auto = {}
      }
      if (!res.driver) {
        res.driver = {}
      }

      return res
    },
    checkedFlightsList() {
      return this.flightsList.filter(flight => this.checked.includes(flight.id))
    },
  },
  watch: {
    $route: {
      handler: 'updateByRoute',
      immediate: true,
    },
  },
  created() {
    if (this.$route.query.error) {
      this.$message({
        message: this.$route.query.error,
        type: 'error',
        duration: 60000,
        onClose: this.redirectAfterError,
        offset: 50,
        showClose: true,
      })
    }
  },
  methods: {
    ...mapMutations({ updateResponse: 'responses/updateResponse' }),
    redirectAfterError() {
      window.history.go(-1)
    },
    updateByRoute(route) {
      const search =
        route && route.query.search ? { search: route.query.search } : {}

      this.onSearch(search)
    },
    onSearch(search = {}) {
      this.search = { ...search }
      this.page = 1
      this.getFlightsList()
    },
    changePage(page = 1) {
      this.page = page
      this.getFlightsList()
    },
    getFlightsList() {
      let { search, page, access } = this

      this.$store.dispatch('responses/fetchFlights', {
        ...search,
        page,
        access,
      })
    },
    onCheckAll(val) {
      this.checked = val ? this.flightsList.map(f => f.id) : []
      this.indeterminate = false
    },
    onCheckOne(val) {
      const checkedCount = val.length

      this.checkAll = checkedCount === this.flightsList.length
      this.indeterminate =
        checkedCount > 0 && checkedCount < this.flightsList.length
    },
    setOpen(data, key = '', field = '', fieldData = null) {
      this.response = data

      if (field) {
        this[field] = fieldData
      }
      if (key) {
        this[key] = true
      }
    },
    setClose(key = '', field = '') {
      this.response = null

      if (field) {
        this[field] = null
      }
      if (key) {
        this[key] = false
      }
    },
    updateAct() {
      if (this.response && this.response.id) {
        this.$store.dispatch('responses/fetchFlightAct', this.response.id)
        this.$store.dispatch('responses/fetchFlight', this.response.id)
      }
    },
    updateTTN() {
      if (this.TTNMode && this.TTNMode.id) {
        this.$store.dispatch('responses/fetchFlightTTN', this.TTNMode.id)
      }
    },
    updateFlight(flag, id) {
      this.$store.dispatch('responses/fetchFlight', id)
    },
  },
}
</script>

<style lang="sass">
.flights-list
  font-size: 14px
  color: #000
  .titles
    text-align: center
    .direction
      text-align: left
</style>
